import aiModel from './reducers/aiModel';
import animation from './reducers/animation';
import appMode from './reducers/appMode';
import chatToken from './reducers/chatToken';
import width from './reducers/dimension';
import errorToast from './reducers/errorToast';
import hasScroll from './reducers/hasScroll';
import messages from './reducers/message';
import sidebar from './reducers/sidebar';
import sources from './reducers/sources';
import successToast from './reducers/successToast';
import userFront from './reducers/userFront';
import widget from './reducers/widget';

export const reducerList = {
	sources,
	messages,
	animation,
	width,
	chatToken,
	sidebar,
	hasScroll,
	aiModel,
	userFront,
	errorToast,
	successToast,
	widget,
	appMode
};

export default reducerList;
